export const aboutKeys = {
  // Hero
  heroHeadline: "heroHeadline",
  heroCta: "heroCta",
  heroOpenRoles: "heroOpenRoles",

  // Problem
  problemLabel: "problemLabel",
  problemHeadline: "problemHeadline",
  problemBody: "problemBody",
  problemStatValue: "problemStatValue",
  problemStatDesc: "problemStatDesc",
  problemStatSource: "problemStatSource",
  problemStat2Value: "problemStat2Value",
  problemStat2Text: "problemStat2Text",

  // Approach
  approachLabel: "approachLabel",
  approachHeadline: "approachHeadline",

  // Values
  valuesLabel: "valuesLabel",
  valuesHeading: "valuesHeading",
  valueTrustedSidekickName: "valueTrustedSidekickName",
  valueTrustedSidekickDesc: "valueTrustedSidekickDesc",
  valueAlwaysThereName: "valueAlwaysThereName",
  valueAlwaysThereDesc: "valueAlwaysThereDesc",
  valueBetterEveryDayName: "valueBetterEveryDayName",
  valueBetterEveryDayDesc: "valueBetterEveryDayDesc",
  valueActionablyProactiveName: "valueActionablyProactiveName",
  valueActionablyProactiveDesc: "valueActionablyProactiveDesc",
  valueGrittyName: "valueGrittyName",
  valueGrittyDesc: "valueGrittyDesc",
  valueThinkBigName: "valueThinkBigName",
  valueThinkBigDesc: "valueThinkBigDesc",

  // Team
  teamLabel: "teamLabel",
  teamHeadline: "teamHeadline",
  teamSubtitle: "teamSubtitle",
  advisoryBoardLabel: "advisoryBoardLabel",
  medicalPartnerRole: "medicalPartnerRole",
  medicalPartnerTitle: "medicalPartnerTitle",
  advisorCredential1: "advisorCredential1",
  advisorCredential2: "advisorCredential2",
  advisorCredential3: "advisorCredential3",
  advisorCredential4: "advisorCredential4",
  widerTeamLabel: "widerTeamLabel",

  // Leadership titles
  leadershipNickTitle: "leadershipNickTitle",
  leadershipSvenTitle: "leadershipSvenTitle",
  leadershipDennisTitle: "leadershipDennisTitle",
  leadershipVegaTitle: "leadershipVegaTitle",

  // Wider team roles
  widerTeamClinicalOps: "widerTeamClinicalOps",
  widerTeamGpPrevention: "widerTeamGpPrevention",
  widerTeamGpPreventionM: "widerTeamGpPreventionM",
  widerTeamSoftwareEngineer: "widerTeamSoftwareEngineer",
  widerTeamProductDesigner: "widerTeamProductDesigner",
  widerTeamProductMarketer: "widerTeamProductMarketer",
  widerTeamCustomerSuccess: "widerTeamCustomerSuccess",
  widerTeamChiefOfStaff: "widerTeamChiefOfStaff",
  widerTeamHeadOfGrowth: "widerTeamHeadOfGrowth",
  widerTeamHeadOfMarketing: "widerTeamHeadOfMarketing",
  widerTeamFoundingSeniorProductEngineer:
    "widerTeamFoundingSeniorProductEngineer",
  widerTeamClinicalOpsHealthData: "widerTeamClinicalOpsHealthData",
  widerTeamFoundingAiMlEngineer: "widerTeamFoundingAiMlEngineer",

  // Angel affiliations (translatable ones only)
  angelHuggingFaceAffiliation: "angelHuggingFaceAffiliation",

  // Investors
  investorsLabel: "investorsLabel",
  investorsHeadline: "investorsHeadline",
  investorsAngelsLabel: "investorsAngelsLabel",

  // Careers
  careersLabel: "careersLabel",
  careersHeadline: "careersHeadline",
  careersSeeRole: "careersSeeRole",
  careersOpenAppTitle: "careersOpenAppTitle",
  careersOpenAppDesc: "careersOpenAppDesc",
  careersOpenAppCta: "careersOpenAppCta",

  // Closing
  closingHeadline: "closingHeadline",
  closingHeadlineBold: "closingHeadlineBold",
  closingCta: "closingCta",

  // Hero value proposition
  heroValueProp: "heroValueProp",
  heroValuePropBlood: "heroValuePropBlood",

  // What Ahead Health does
  servicesHeading: "servicesHeading",
  serviceCheckupTitle: "serviceCheckupTitle",
  serviceCheckupDesc: "serviceCheckupDesc",
  serviceMriTitle: "serviceMriTitle",
  serviceMriDesc: "serviceMriDesc",
  serviceBloodDesc: "serviceBloodDesc",
  servicePlanTitle: "servicePlanTitle",
  servicePlanDesc: "servicePlanDesc",

  // What makes Ahead Health different
  differentHeading: "differentHeading",
  differentEyebrow: "differentEyebrow",
  differentIntro: "differentIntro",
  diffAheadLabel: "diffAheadLabel",
  diffStandardLabel: "diffStandardLabel",
  diff1Title: "diff1Title",
  diff1Desc: "diff1Desc",
  diff1Ahead: "diff1Ahead",
  diff1Standard: "diff1Standard",
  diff2Title: "diff2Title",
  diff2Desc: "diff2Desc",
  diff2Ahead: "diff2Ahead",
  diff2Standard: "diff2Standard",
  diff3Title: "diff3Title",
  diff3Desc: "diff3Desc",
  diff3Ahead: "diff3Ahead",
  diff3Standard: "diff3Standard",
  diff4Title: "diff4Title",
  diff4Desc: "diff4Desc",
  diff4Ahead: "diff4Ahead",
  diff4Standard: "diff4Standard",
  diff5Title: "diff5Title",
  diff5Desc: "diff5Desc",
  diff5Ahead: "diff5Ahead",
  diff5Standard: "diff5Standard",

  // Who uses Ahead Health
  whoHeading: "whoHeading",
  whoEyebrow: "whoEyebrow",
  whoIntro: "whoIntro",
  who1Title: "who1Title",
  who1Desc: "who1Desc",
  who1DescBlood: "who1DescBlood",
  who2Title: "who2Title",
  who2Desc: "who2Desc",
  who3Title: "who3Title",
  who3Desc: "who3Desc",
  who4Title: "who4Title",
  who4Desc: "who4Desc",
  who5Title: "who5Title",
  who5Desc: "who5Desc",
  who6Title: "who6Title",
  who6Desc: "who6Desc",
  who7Title: "who7Title",
  who7Desc: "who7Desc",
  who8Title: "who8Title",
  who8Desc: "who8Desc",

  // Team origin
  teamHeading: "teamHeading",
  teamOrigin: "teamOrigin",

  // How Ahead Health works
  howHeading: "howHeading",
  howEyebrow: "howEyebrow",
  howCheckupTitle: "howCheckupTitle",
  howCheckup1: "howCheckup1",
  howCheckup2: "howCheckup2",
  howCheckup2Blood: "howCheckup2Blood",
  howCheckup3: "howCheckup3",
  howCheckup3Blood: "howCheckup3Blood",
  howCheckup4: "howCheckup4",
  howCheckup5: "howCheckup5",
  howContactTitle: "howContactTitle",
  howContactWhatsapp: "howContactWhatsapp",
  howContactPhone: "howContactPhone",
  howContactEmail: "howContactEmail",
  howContactCall: "howContactCall",

  // Key facts
  factsHeading: "factsHeading",
  factsEyebrow: "factsEyebrow",
  factsShowAll: "factsShowAll",
  factsShowFewer: "factsShowFewer",
  factCompanyLabel: "factCompanyLabel",
  factFoundedLabel: "factFoundedLabel",
  factFoundedValue: "factFoundedValue",
  factFoundersLabel: "factFoundersLabel",
  factHeadquartersLabel: "factHeadquartersLabel",
  factOfferingLabel: "factOfferingLabel",
  factOfferingValue: "factOfferingValue",
  factOfferingValueBlood: "factOfferingValueBlood",
  factLocationsLabel: "factLocationsLabel",
  factCustomersLabel: "factCustomersLabel",
  factRatingLabel: "factRatingLabel",
  factRatingCount: "factRatingCount",
  factLegalNameLabel: "factLegalNameLabel",
  factUidLabel: "factUidLabel",
  factTypeLabel: "factTypeLabel",
  factTypeValue: "factTypeValue",
  factWebsiteLabel: "factWebsiteLabel",
  factPricingLabel: "factPricingLabel",
  factPricingValue: "factPricingValue",
  factServicesLabel: "factServicesLabel",
  factServicesValue: "factServicesValue",
  factServicesValueBlood: "factServicesValueBlood",
  factContactLabel: "factContactLabel",
  factMedicalTeamLabel: "factMedicalTeamLabel",
  factMedicalTeamValue: "factMedicalTeamValue",
  factSocialLabel: "factSocialLabel",

  // Company FAQ
  faqHeading: "faqHeading",
  faqEyebrow: "faqEyebrow",
} as const
